export function normalizeSavedCards(cards) {
  if (!Array.isArray(cards)) return [];

  return cards
    .map(card => ({
      ...card,
      // Keep compatibility with older backend responses that used "default".
      isDefault: card.isDefault ?? card.default ?? false,
    }))
    .sort((a, b) => Number(a.id) - Number(b.id));
}

export function getDefaultSavedCard(cards) {
  if (!Array.isArray(cards) || cards.length === 0) return null;
  return cards.find(card => card.isDefault) ?? cards[0];
}
